import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-200/80">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-1">
              <span className="font-heading text-xl font-bold text-background-50">调教指南</span>
              <p className="mt-3 text-sm leading-relaxed text-background-300/70">
                用科学塑造行为，以专业成就卓越。国内领先的行为科学与技能训练知识平台。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                内容分类
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/category/pet-training" className="text-sm text-background-300/70 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    宠物调教
                  </Link>
                </li>
                <li>
                  <Link to="/category/skill-training" className="text-sm text-background-300/70 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    技能调教训练
                  </Link>
                </li>
                <li>
                  <Link to="/category/behavior-modification" className="text-sm text-background-300/70 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    行为调教技巧
                  </Link>
                </li>
                <li>
                  <Link to="/category/self-improvement" className="text-sm text-background-300/70 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    自我调教提升
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                快速链接
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-300/70 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-300/70 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/category/strategy-guide" className="text-sm text-background-300/70 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    调教策略指南
                  </Link>
                </li>
                <li>
                  <Link to="/category/education-training" className="text-sm text-background-300/70 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    教育调教方法
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                联系我们
              </h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-background-300/70">
                  <i className="ri-mail-line text-sm"></i>
                  <span>contact@tiaojiao-guide.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-300/70">
                  <i className="ri-phone-line text-sm"></i>
                  <span>400-888-9999</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-300/70">
                  <i className="ri-map-pin-line text-sm"></i>
                  <span>北京市朝阳区科学路88号</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-300/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-300/50">
              &copy; 2026 调教指南. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-300/50 hover:text-background-100 transition-colors duration-200 cursor-pointer" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-300/50 hover:text-background-100 transition-colors duration-200 cursor-pointer" rel="nofollow">
                使用条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}